<template>
  <CFooter :fixed="false">
    <div>
      <span class="ml-1"
        >Copyright &copy; {{ new Date().getFullYear() }} Fabbi JSC. All rights
        reserved.
      </span>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: "Footer"
};
</script>
